import { axiosClient } from "api/api";
import { encryptResult, decryptResult } from "./encryption_decryption";

export const secureGet = async (url, params) => {
  try {
    const encryptedParams = encryptResult(JSON.stringify(params));
    const response = await axiosClient.get(`${url}?params=${encodeURIComponent(encryptedParams)}`);
    
    if (!response || !response.data) {
      console.error("Unexpected response format:", response.data);
      throw new Error("Invalid encrypted response");
    }

    return decryptResult(response.data);
  } catch (error) {
    console.error("Decryption Error:", error);
    throw error;
  }
};

export const securePost = async (url, data) => {
  try {
    const encryptedPayload = encryptResult(JSON.stringify(data));
    const response = await axiosClient.post(url, { encryptedPayload });
    
    if (!response || !response.data) {
      console.error("Unexpected response format:", response.data);
      throw new Error("Invalid encrypted response");
    }

    return decryptResult(response.data);
  } catch (error) {
    console.error("Encryption Error:", error);
    throw error;
  }
};